import dynamic from "next/dynamic";

export const ContentSideVideo = dynamic(() => import("./component"));
